"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCardLink = exports.renderButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _BoundedCardLinkIcon = require("./BoundedCardLinkIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderButton = (buttonContent, Link, VideoComponent, override, setOverride, cssClass) => {
  let buttonTarget = (0, _CTASectionMethods.checkForExternalLink)(buttonContent?.url);
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    video: buttonContent?.video,
    VideoComponent: VideoComponent,
    override: override,
    setOverride: setOverride,
    name: buttonContent?.name || null,
    text: buttonContent?.text || null,
    className: buttonContent?.type || `ter-button--primary--1 ${cssClass}`,
    onClick: buttonContent?.onClick || null,
    url: buttonContent?.url || null,
    external: buttonTarget,
    Link: Link
  });
};
exports.renderButton = renderButton;
const renderCardLink = (cardLink, Link, isExternal, VideoComponent, override, setOverride, cssClass) => {
  if (cardLink?.video) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      className: `ter-bounded-card__link ${cssClass}`,
      onClick: () => {
        setOverride(true);
      },
      Link: Link && Link
    }, cardLink?.text || text || children, /*#__PURE__*/_react.default.createElement(_BoundedCardLinkIcon.CardLinkIcon, {
      iconClass: "ter-bounded-card__link-icon",
      external: false
    }), override && VideoComponent && /*#__PURE__*/_react.default.createElement(VideoComponent, {
      setOverride: setOverride,
      override: override,
      content: video
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: `ter-bounded-card__link ${cssClass}`,
    to: cardLink?.url,
    Link: Link && Link,
    onClick: cardLink?.onClick,
    contentfulId: cardLink?.contentfulId
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-bounded-card__link-text"
  }, cardLink?.text), /*#__PURE__*/_react.default.createElement(_BoundedCardLinkIcon.CardLinkIcon, {
    iconClass: "ter-bounded-card__link-icon",
    external: (0, _CTASectionMethods.checkForExternalLink)(cardLink?.url)
  }));
};
exports.renderCardLink = renderCardLink;